import type { BariPostEnrollmentDataV1 } from '@common/validation/customControls/bariPost/bariPostEnrollment/v1/bariPostEnrollmentDataV1';

export const initialDataV1: BariPostEnrollmentDataV1 = {
    assets: [],
    bijzonderheden: null,
    bijzonderheden_labwaarden: null,
    bijzonderheden_labwaarden_omschrijving: null,
    bijzonderheden_omschrijving: null,
    complicatie_type: null,
    complicaties: null,
    complicaties_omschrijving: null,
    datum_lab_geprikt: null,
    datum_operatie: null,
    gewicht_voor_operatie: null,
    ingreep: null,
    naam_chirurg: null,
};
